import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import CoparentPage from './CoparentPage';

const CoparentRoute: FuseRouteItemType[] = [
  {
    path: 'authentication/co-parent-invite',
    element: <CoparentPage />,
    auth: null,
  },
];

export default CoparentRoute;
